import {MakeStore, StoreObject} from "../../stem-core/src/state/Store.js";
import {BaseEnum, makeEnum} from "../../stem-core/src/state/BaseEnum.js";
import {field} from "../../stem-core/src/state/StoreField.js";
import {apiClient} from "../connection/BlinkApiClient.js";


@makeEnum
export class PaymentProcessorType extends BaseEnum {
    static BLINK_CREDIT;
    static STRIPE;
    static CDS;
    static AMAZON;
    static PAYPAL;
    static CDS_LEGACY;

    toString() {
        if (this === this.constructor.AMAZON) {
            return "Amazon Pay"
        }
        if (this === this.constructor.PAYPAL) {
            return "PayPal"
        }
        return super.toString();
    }
}

class PaymentProcessor extends StoreObject {
    @field(PaymentProcessorType) provider;
    @field("Merchant") merchant;
    @field("LegalEntity") legalEntity;
    @field(String) publicKey;
    @field(Object) publicConfig;
    @field(Boolean) isPublic;
    @field(Boolean) isActive;
    @field(Boolean) isEditable;
    @field(Boolean) supportsDonations;
    @field(Boolean) supportsRecurring;

    toString() {
        return `${this.provider} ${this.isPublic ? "public" : "private"} ${this.merchant || "Blink"}`;
    }
}

export const PaymentProcessorStore = MakeStore("PaymentProcessor", PaymentProcessor);

export async function apiMerchantEditPaymentProcessor(request) {
    return apiClient.post("/merchant/edit_payment_processor", request);
}
